export default __webpack_public_path__ + "static/GT-Super-Display-Light-Italic-8e61b36a998cfc8087395d0d3028e9c7.woff2";